var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spring-spinner",class:{ 'spring-spinner--small': _vm.small }},[_vm._m(0),_vm._m(1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spring-spinner-part top"},[_c('div',{staticClass:"spring-spinner-rotator"})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spring-spinner-part bottom"},[_c('div',{staticClass:"spring-spinner-rotator"})])
}]

export { render, staticRenderFns }